module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/126-botswana-1455a22996af29868fe3c57990c1da6d.svg";